import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { CapabilityEngineService } from '../capabilityEngine.service';
import { Constants } from '../constants';
@Injectable()
export class HazardsService {

    constructor(
        private _http: HttpClient,
        private _capEngineService: CapabilityEngineService,
        private constants: Constants
    ) { }

    getSubmittedForms() {
        let header = this._capEngineService.getHeaders('viewTaskList');
        return this._http.get(environment.serverUrl + '/tasks', header);
    }

    getRawData() {
     return this._http.get(environment.serverUrl + '/rawData/');
    }

    getHazards() {
        let header = this._capEngineService.getHeaders('viewTaskTemplateList');
        return this._http.get(environment.serverUrl + '/taskTemplate/' + this.getHazardTemplateId(), header);
    }

    getHazardTemplateId() {
        if(localStorage.getItem("hazardTemplateId")) {
          return localStorage.getItem("hazardTemplateId")
        } else {
          return this.constants.HAZARD_TEMPLATE_ID
        }
      }

}



// WEBPACK FOOTER //
// ./src/app/hazards/hazards.service.ts